import { apiSlice } from "./apiSlice";
import { IServerSideGetRowsRequest } from "@ag-grid-community/core";
import { transformDataDictionaryItem } from "../features/data-wrangler/UtilityFunctions";

export const dataDictionaryApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDataDictionary: builder.mutation<any, {
            database: string;
            request: IServerSideGetRowsRequest,
            search: string
        }>({
            query: ({ database, request, search }) => {
                const body: any = {
                    database: database,
                    ...request
                }
                if (search) body.search = search.trim();
                return {
                    url: 'public/datadict/server',
                    method: 'POST',
                    body: body,
                }
            },
            transformResponse: (responseData: {
                totalRows: number,
                rows: any[],
                filters: { domain: string[], table_label: string[] }
            }) => {
                return {
                    totalRows: responseData.totalRows ?? 0,
                    rows: responseData?.rows?.map((item: any) => {
                        return transformDataDictionaryItem(item)
                    })
                }
            },
        }),
        getFieldFilter: builder.mutation<any, { filterModel: any, field: string }>({
            query: ({ filterModel, field }) => {
                return {
                    url: `public/datadict/server/filter/${field}`,
                    method: 'POST',
                    body: { filterModel },
                }
            }
        }),
        getSelectedFields: builder.mutation({
            query: ({ database, filterModel, search, excluded }) => {
                const body: any = {
                    database: database,
                    filterModel: filterModel
                }
                if (search) body.search = search;
                return {
                    url: '/datadict/selected',
                    method: 'POST',
                    body: {
                        queryParams: body,
                        excludedIds: excluded
                    },
                }
            },
            transformResponse: (responseData: {
                id: number,
                tableLabel: string,
                tableName: string,
                name: string,
            }[]) => {
                return responseData.map((row) => {
                    return {
                        id: row.id,
                        table_label: row.tableLabel,
                        table_name: row.tableName,
                        name: row.name
                    };
                });
            }
        }),
        getInstrumentFieldCount: builder.mutation({
            query: (instruments) => {
                return {
                    url: `/datadict/instrument/field/count`,
                    method: 'POST',
                    body: instruments,
                }
            }
        })
    })
})

export const {
    useGetDataDictionaryMutation,
    useGetFieldFilterMutation,
    useGetSelectedFieldsMutation,
    useGetInstrumentFieldCountMutation
} = dataDictionaryApiSlice;